<ng-container *ngFor="let lesson of lessons">
  <app-day-schedule-lesson *ngIf="homeMode; else defaultLesson" [lesson]="lesson" [single]="lessons.length === 1" [spaceBefore]="lesson.spaceBefore || 0" 
    [onlineClassText]="onlineClassText" [cancelledClassText]="cancelledClassText" [hibridClassText]="hibridClassText" [notificationsHeaderText]="notificationsHeaderText"/>

  <ng-template #defaultLesson>
    <app-schedule-lesson [lesson]="lesson" [single]="lessons.length === 1" [spaceBefore]="lesson.spaceBefore || 0" 
    [onlineClassText]="onlineClassText" [cancelledClassText]="cancelledClassText" [hibridClassText]="hibridClassText"/>
  </ng-template>
</ng-container>
